var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackTitle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 319.094,
    height: 61.333,
    viewBox: "0 0 319.094 61.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_657",
    "data-name": "Grupo 657",
    transform: "translate(-1772.5 -2441.782)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_651",
    "data-name": "Grupo 651",
    transform: "translate(897.576 -463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_4",
    "data-name": "Uni\\xE3o 4",
    d: "M15.429,37.962V27.639H10.176V22.644H0V15.318H10.176v-5H4.924V5h5.252v5.328h5.252V0H302.993V10.323h5.252v5h9.848v7.326h-9.848v4.995h-5.252V37.962Zm292.817-5V27.639H313.5v5.328Zm-303.321,0V27.639h5.252v5.328ZM308.246,10.323V5H313.5v5.328Z",
    transform: "translate(875.423 2911.828)",
    fill: "#38243f",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_3",
    "data-name": "Uni\\xE3o 3",
    d: "M15.429,37.962V27.639H10.176V22.644H0V15.318H10.176v-5H4.924V5h5.252v5.328h5.252V0H302.993V10.323h5.252v5h9.848v7.326h-9.848v4.995h-5.252V37.962Zm292.817-5V27.639H313.5v5.328Zm-303.321,0V27.639h5.252v5.328ZM308.246,10.323V5H313.5v5.328Z",
    transform: "translate(875.423 2905.282)",
    fill: "#e7e6dd",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_652",
    "data-name": "Grupo 652",
    transform: "translate(898.105 -463)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xE3o_1",
    "data-name": "Uni\\xE3o 1",
    d: "M8.345,21.826V14.764H0v-7.7H8.345V0H108.807V7.061h8.345v7.7h-8.345v7.061Z",
    transform: "translate(975.895 2943.79)",
    fill: "#92133a",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackTitle);
export default __webpack_public_path__ + "static/media/backTitle.dd1ea1c443f79d4059597e869ac17a6f.svg";
export { ForwardRef as ReactComponent };